import { CheckIcon } from "assets/icons";
import {
  useGetOperatorListQuery,
  useGetFacilityListQuery,
} from "../../redux/services/busSearchServices";

function BusFilters({
  setOpenFilters,
  selectedFilters,
  setSelectedFilters,
  searchResults,
  setSearchResults,
}) {
  const { data: operatorResponse } = useGetOperatorListQuery();
  const { data: facilityResponse } = useGetFacilityListQuery();

  const times = [
    {
      label: "(Morning)",
      timestamp: "06:00 - 12:00",
      image: "/images/morning.svg",
    },
    {
      label: "(Afternoon)",
      timestamp: "12:00 - 18:00",
      image: "/images/afternoon.svg",
    },
    {
      label: "(Evening)",
      timestamp: "18:00 - 24:00",
      image: "/images/evening.svg",
    },
    {
      label: "(Night)",
      timestamp: "00:00 - 06:00",
      image: "/images/night.svg",
    },
  ];

  const busTypes = [
    {
      label: "Executive (2+1)",
      value: "executive",
    },
    {
      label: "Economy",
      value: "economy",
    },
  ];

  const toggleSelection = (type, id) => {
    let _id = Number(id);
    if (type === "operator") {
      setSelectedFilters({
        ...selectedFilters,
        operatorList: _id === selectedFilters.operatorList ? 0 : _id,
      });
    } else if (type === "facility") {
      const isSelected = selectedFilters.facilityList.includes(_id);
      setSelectedFilters({
        ...selectedFilters,
        facilityList: isSelected
          ? selectedFilters.facilityList.filter((item) => item !== _id)
          : [...selectedFilters.facilityList, _id],
      });
    }
  };

  const handlePriceFilter = () => {
    const newSortByPrice =
      selectedFilters.sortByPrice === "low-to-high-price"
        ? ""
        : "low-to-high-price";

    setSelectedFilters({
      ...selectedFilters,
      sortByPrice: newSortByPrice,
    });

    if (newSortByPrice === "low-to-high-price") {
      const sortedResults = [...searchResults].sort(
        (a, b) => parseFloat(a.bus_rate) - parseFloat(b.bus_rate)
      );
      setSearchResults(sortedResults);
    } else {
      const sortedResults = [...searchResults].sort(
        (a, b) => parseFloat(b.bus_rate) - parseFloat(a.bus_rate)
      );
      setSearchResults(sortedResults);
    }
  };

  return (
    <div className="w-full bg-white lg:p-8 flex flex-col h-full">
      <div className="w-full flex items-center mb-5 lg:mb-8 p-4 lg:p-0 border-b-[1px] border-[#C4C4C480] lg:border-none sticky top-0 bg-white z-10">
        <div className="flex-1 text-lg font-semibold text-[#112211]">
          Filter Buses
        </div>
        <button
          onClick={() => setOpenFilters(false)}
          className="text-4xl font-light flex lg:hidden"
        >
          &times;
        </button>
      </div>
      <div className="w-full flex flex-col overflow-y-auto px-4 bg-white flex-grow">
        <div className="w-full flex flex-col gap-4">
          <div className="text-base font-semibold text-[#112211]">Sort By</div>
          <div className="w-full flex flex-col gap-2.5">
            <label
              onClick={handlePriceFilter}
              className="w-full flex items-center"
            >
              <div className="flex-1 text-sm text-[#112211] font-medium">
                Price - Low to high
              </div>
              <div
                className={`h-[18px] w-[18px] border-[2px] border-primary-700 rounded-[2px] flex items-center justify-center animation ${
                  selectedFilters.sortByPrice === "low-to-high-price"
                    ? "bg-primary-700 text-white"
                    : ""
                }`}
              >
                {selectedFilters.sortByPrice === "low-to-high-price" && (
                  <CheckIcon />
                )}
              </div>
            </label>
            <label className="w-full flex items-center">
              <div className="flex-1 text-sm text-[#112211] font-medium">
                Best rated first
              </div>
              <div
                className={`h-[18px] w-[18px] border-[2px] border-primary-700 rounded-[2px] flex items-center justify-center animation`}
              ></div>
            </label>
            <label className="w-full flex items-center">
              <div className="flex-1 text-sm text-[#112211] font-medium">
                Early departure
              </div>
              <div
                className={`h-[18px] w-[18px] border-[2px] border-primary-700 rounded-[2px] flex items-center justify-center animation`}
              ></div>
            </label>
            <label className="w-full flex items-center">
              <div className="flex-1 text-sm text-[#112211] font-medium">
                Late departure
              </div>
              <div
                className={`h-[18px] w-[18px] border-[2px] border-primary-700 rounded-[2px] flex items-center justify-center animation`}
              ></div>
            </label>
          </div>
        </div>

        <div className="w-full h-[0.5px] bg-[#112211]/25 my-4 lg:my-8" />

        <div className="w-full flex flex-col gap-4">
          <div className="text-base font-semibold text-[#112211]">
            Departure Time from Source
          </div>
          <div className="w-full flex flex-col gap-2.5">
            {times.map((item, index) => (
              <div key={index} className="w-full flex items-center">
                <div className="flex items-center gap-2 flex-1">
                  <img src={item.image} alt="" />
                  <div className="text-sm text-[#112211] font-medium">
                    {item.timestamp}{" "}
                    <span className="font-light">{item.label}</span>
                  </div>
                </div>
                <button className="h-[18px] w-[18px] rounded-full border-[2px] border-primary-700 flex items-center justify-center"></button>
              </div>
            ))}
          </div>
        </div>

        <div className="w-full h-[0.5px] bg-[#112211]/25 my-4 lg:my-8" />

        <div className="w-full flex flex-col gap-4">
          <div className="text-base font-semibold text-[#112211]">
            Arrival Time at Destination
          </div>
          <div className="w-full flex flex-col gap-2.5">
            {times.map((item, index) => (
              <label key={index} className="w-full flex items-center">
                <div className="flex items-center gap-2 flex-1">
                  <img src={item.image} alt="" />
                  <div className="text-sm text-[#112211] font-medium">
                    {item.timestamp}{" "}
                    <span className="font-light">{item.label}</span>
                  </div>
                </div>
                <button
                  className={`h-[18px] w-[18px] rounded-full border-[2px] border-primary-700 flex items-center justify-center`}
                ></button>
              </label>
            ))}
          </div>
        </div>

        <div className="w-full h-[0.5px] bg-[#112211]/25 my-4 lg:my-8" />

        <div className="w-full flex flex-col gap-4">
          <div className="text-base font-semibold text-[#112211]">Bus Type</div>
          <div className="w-full flex flex-col gap-2.5">
            {busTypes.map((item, index) => (
              <div key={index} className="w-full flex items-center">
                <div className="flex-1 text-sm text-[#112211] font-medium">
                  {item.label}
                </div>
                <button className="h-[18px] w-[18px] rounded-full border-[2px] border-primary-700 flex items-center justify-center"></button>
              </div>
            ))}
          </div>
        </div>
        {facilityResponse?.facilitylist && (
          <>
            <div className="w-full h-[0.5px] bg-[#112211]/25 my-4 lg:my-8" />
            <div className="w-full flex flex-col gap-4">
              <div className="text-base font-semibold text-[#112211]">
                Amenities
              </div>
              <div className="w-full flex flex-col gap-2.5">
                {facilityResponse?.facilitylist.map((item, index) => (
                  <label key={index} className="w-full flex items-center">
                    <div className="flex-1 text-sm text-[#112211] font-medium">
                      {item.title}
                    </div>
                    <button
                      className="h-[18px] w-[18px] p-0.5 rounded-full border-[2px] border-primary-700 flex items-center justify-center"
                      onClick={() => toggleSelection("facility", item.id)}
                    >
                      <div
                        className={`h-full w-full rounded-full animation ${
                          selectedFilters.facilityList.includes(Number(item.id))
                            ? "bg-primary-700"
                            : "bg-transparent"
                        }`}
                      />
                    </button>
                  </label>
                ))}
              </div>
            </div>
          </>
        )}

        {operatorResponse?.operatorlist?.length && (
          <>
            <div className="w-full h-[0.5px] bg-[#112211]/25 my-4 lg:my-8" />
            <div className="w-full flex flex-col gap-4">
              <div className="text-base font-semibold text-[#112211]">
                Bus Operator
              </div>
              <div className="w-full flex flex-col gap-2.5">
                {operatorResponse?.operatorlist.map((item, index) => (
                  <label key={index} className="w-full flex items-center">
                    <div className="flex-1 text-sm text-[#112211] font-medium">
                      {item.title}
                    </div>
                    <button
                      className="h-[18px] w-[18px] p-0.5 rounded-full border-[2px] border-primary-700 flex items-center justify-center"
                      onClick={() =>
                        toggleSelection("operator", Number(item.id))
                      }
                    >
                      <div
                        className={`h-full w-full rounded-full animation ${
                          selectedFilters.operatorList === Number(item.id)
                            ? "bg-primary-700"
                            : "bg-transparent"
                        }`}
                      />
                    </button>
                  </label>
                ))}
              </div>
            </div>
          </>
        )}

        <div className="w-full h-[0.5px] bg-[#112211]/25 my-4 lg:my-8" />

        <div className="w-full flex flex-col md:flex-row items-center gap-3 md:gap-4 mb-10 lg:mb-0">
          <button className="w-full h-[48px] bg-black text-sm text-white font-semibold rounded-[8px] hover:opacity-90 animation">
            Clear All
          </button>
          <button className="w-full h-[48px] bg-primary-700 text-sm text-white font-semibold rounded-[8px] hover:opacity-90 animation">
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
export default BusFilters;
